export enum NewEnvelopeSteps {
    Upload = 'new-envelope.step.Upload',
    Settings = 'new-envelope.step.Settings',
    Signatory = 'new-envelope.step.Signatory',
    Signatures = 'new-envelope.step.Signatures',
    Review = 'new-envelope.step.Review'
}

export class NewEnvelopeStepsUtil {
    public static getEnvelopeStep(value: String): NewEnvelopeSteps {
        const stepEnum = value as NewEnvelopeSteps;
        return stepEnum;
    }

    public static getEnvelopeStepIndex(value: NewEnvelopeSteps): number {
        const splittedString = value.split('.');
        return Object.keys(NewEnvelopeSteps).indexOf(splittedString[splittedString.length - 1]);
    }
}
